import { render, staticRenderFns } from "./setting-form.vue?vue&type=template&id=561be438&scoped=true&"
import script from "./setting-form.vue?vue&type=script&lang=js&"
export * from "./setting-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561be438",
  null
  
)

export default component.exports